
































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import Thread from '../../../api/v2/models/thread'
import api from '../../../api/v2/api'
@Component({})
export default class ThreadContainer extends Vue {
  @Prop({ default: 'Lesson' }) targetableType: 'Lesson' | 'UserGoal'
  @Prop({ required: true }) targetableId: string
  @Prop({ default: 2 }) parentTab: number
  threads: Thread[] = []
  showDeleteDialog: boolean = false
  showEditDialog: boolean = false
  selectedThread: Thread | null = null
  threadName: string = ''
  async created() {
    try {
      this.threads = await api.thread.index({ targetableId: this.targetableId, targetableType: this.targetableType })
    } catch (e) {}
  }
  clickThread(id: number) {
    this.$emit('updateParentTab', this.parentTab)
    this.$router
        .push({
          query: { ...this.$route.query, thread_id: id.toString() }
        })
        .catch((error) => {
          if (error.name != 'NavigationDuplicated') {
            throw error
          }
        })
  }

  openDeleteDialog(thread: Thread) {
    this.selectedThread = thread
    this.showDeleteDialog = true
  }
  openEditDialog(thread: Thread) {
    this.selectedThread = thread
    this.threadName = thread.name
    this.showEditDialog = true
  }
  async deleteThread() {
    try {
      await api.thread.delete(this.selectedThread.id)
      this.threads = this.threads.filter((thread) => thread.id !== this.selectedThread.id)
      this.showDeleteDialog = false
    } catch (e) {}
  }
  async editThread() {
    try {
      await api.thread.update(this.selectedThread.id, { name: this.threadName })
      this.selectedThread.name = this.threadName
      this.showEditDialog = false
    } catch (e) {}
  }
}
